<template>
  <div class="new-template-form">
    <AppForm @submit.prevent="addTemplate">
      <!-- Title -->
      <AppInput label="Título" v-model="title" />
      <!-- Category -->
      <AppMultiselect
        v-model="category"
        :options="categoriesName"
        placeholder="Categoría"
        data-type="category-select"
      />
      <!-- Language -->
      <AppMultiselect
        v-model="language"
        label="name"
        track-by="key"
        placeholder="Idioma"
        data-type="language-select"
        :options="languages"
      />
      <div class="form-actions">
        <SubmitButton type="submit" :disabled="!formHasInfo" :loading="loading">
          Crear
        </SubmitButton>
        <AppButton type="button" variation="magenta" @click="closeModal" inverted>
          Cancelar
        </AppButton>
      </div>
    </AppForm>
  </div>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
// import apiActions from 'Services/actions'
// Components
import AppInput from 'Ui/AppInput'
import AppButton from 'Ui/AppButton'
import AppForm from 'Components/AppForm'
import AppMultiselect from 'Ui/AppMultiselect'
import SubmitButton from 'Components/SubmitButton'

export default {
  name: 'NewTempalteForm',

  components: {
    AppForm,
    AppInput,
    SubmitButton,
    AppMultiselect,
    AppButton,
  },

  data() {
    return {
      title: null,
      category: null,
      language: null,
      categories: [],
      languages: [
        { name: 'Castellano', key: 'es' },
        { name: 'Inglés', key: 'en' },
      ],
      loading: false,
    }
  },

  methods: {
    async addTemplate() {
      this.loading = true
      const newTemplateData = {
        title: this.title,
        category: this.categories.filter((cat) => cat.name_es === this.category)[0].id,
        language: this.language.key,
      }
      // Calling the server
      const apiCall = await this.$store.dispatch('templates/addTemplate', newTemplateData)
      if (apiCall.status >= 200 && apiCall.status <= 299) {
        this.loading = false
        this.closeModal()
        // If success, redirect to the template page
        return this.$router.push({
          name: 'template-edit',
          params: { temp_id: apiCall.data.card_id, temp_title: apiCall.data.slug },
        })
      }
      this.loading = false
    },

    closeModal() {
      EventBus.$emit('close-diy-modal')
    },
  },

  computed: {
    formHasInfo() {
      return this.title && this.category && this.language
    },

    categoriesName() {
      return this.categories.map((cat) => cat.name_es)
    },
  },

  async mounted() {
    // if no categories we loaded them
    if (!this.$store.state.categories.categories) await this.$store.dispatch('categories/load')
    // getting categories
    this.categories = this.$store.state.categories.categories
    // focus on input
    this.$el.querySelector('.app-input').focus()
  },
}
</script>

<style scoped>
.app-heading {
  margin-bottom: 30px;
}

.multiselect {
  margin-top: 20px;
}

.form-actions {
  display: flex;
  max-width: 100%;
  margin-top: 30px;
}

.form-actions >>> .app-button {
  max-width: unset;
}

.submit-button {
  flex: 0 0 50%;
  margin-right: 10px;
}
</style>
